import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, CardHeader, Collapse, Typography } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { ExpandMore } from 'toolkit/info-card/info-card';
import { themeColors } from 'toolkit/styles/colors';
import { timeFormatter } from '@act/shared/utilities';
import './need-history.styles.scss';

export const StyledHistoryEntry = ({
  header,
  content,
  expandedContent,
  footer,
}: {
  header: ReactNode;
  content: ReactNode;
  expandedContent?: ReactNode;
  footer?: ReactNode;
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div>
      <CardHeader
        title={
          <div className="history-entry-title-container">
            <Typography variant="titleSmall" component="div">
              {header}
            </Typography>
            {!!expandedContent && (
              <ExpandMore
                expand={expanded}
                onClick={() => setExpanded(!expanded)}
                aria-expanded={expanded}
                aria-label="show more"
                sx={{ marginTop: '-40px', marginBottom: '-40px' }}
              >
                <ExpandMoreIcon sx={{ color: themeColors.onSurfaceVariant }} />
              </ExpandMore>
            )}
          </div>
        }
        sx={{ padding: '0px 0 8px' }}
      />
      {content}
      {!!expandedContent && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {expandedContent}
        </Collapse>
      )}
      {footer}
    </div>
  );
};

export const StyledHistoryEntrySubheader = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <div>
      <Typography
        sx={{ color: themeColors.onSurfaceVariant }}
        variant="labelMedium"
        component="div"
      >
        {children}
      </Typography>
    </div>
  );
};

export const StyledHistoryEntryDescription = ({
  dateAndUser,
  description,
}: {
  dateAndUser: string;
  description: ReactNode;
}) => {
  return (
    <Box display="flex" flexDirection="column" gap="2px">
      <Typography variant="bodySmall">{dateAndUser}</Typography>
      <Typography variant="bodyMedium">{description}</Typography>
    </Box>
  );
};

export const SubheaderAndDescription = ({
  subheader,
  description,
}: {
  subheader: string;
  description: React.ReactNode;
}) => {
  const descriptionIsString = typeof description === 'string';
  return (
    <div>
      <div>
        <Typography
          sx={{ color: themeColors.onSurfaceVariant }}
          variant="labelMedium"
          component="div"
        >
          {subheader}
        </Typography>
      </div>
      <div>
        {descriptionIsString ? (
          <Typography variant="bodyMedium" component="div">
            {description}
          </Typography>
        ) : (
          description
        )}
      </div>
    </div>
  );
};

export const getHistoryEntryDateLine = (
  dateMillis: number,
  creatorName: string
) => {
  const dateOf = timeFormatter.epochToHumanReadableDate({
    date: dateMillis,
  });

  return `${dateOf} · ${creatorName || 'Unknown'}`;
};
